import React from 'react';
import { fetchEntrepriseKeywords } from '../enterprise.api';

type Props = {
  siren: string;
  children: (keywords: Array<string>) => React.ReactNode;
};

type State = {
  keywords: Array<string>;
};

export class EnterpriseKeywordsFetcher extends React.Component<Props, State> {
  state: State = {
    keywords: [],
  };

  async componentDidMount() {
    const keywords = (await fetchEntrepriseKeywords(this.props.siren)).data;
    this.setState({ keywords });
  }

  render() {
    return this.props.children(this.state.keywords);
  }
}
